import { request } from 'umi';

export async function getTermsAndConditions(locale: string, appType?:string ) {
  return request('/api/cms-pages', {
    method: 'GET',
    params: {
      locale,
      appType
    },
  });
}
